/**
 * Underline styling for the patient demographic bar rendered as a bottom
 * border instead of `text-decoration: underline`. A border is box decoration,
 * so it is not carried into copied text — e.g. the patient User ID pastes as
 * plain text rather than staying underlined. `border-current` matches the
 * text color and `pb-0.5` mirrors the previous `underline-offset-2` gap.
 * Apply to the inline element holding the text (not a block wrapper) so the
 * border tracks the text width.
 */
export const COPY_SAFE_UNDERLINE = "border-b border-current pb-0.5";
